// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__8ZhKr","selected":"Chip_selected__eD3ow"};